module.exports = __webpack_public_path__ + "static/img/icon_03.674a1e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/alipay/icon_03.png
// module id = 155h
// module chunks = 1